export default __webpack_public_path__ + "static/N0246-5400b321a0591bf1f85e541d05feac2c.png";